import { AgentInformationBlock } from '@urbanx/agx.support.client'
import { AgxColumn, AgxRow, AgxTypography } from '@urbanx/agx.ui-components2'
import PoisonQueueInformationTidbit from './PoisonQueueInformationTidbit'
import PoisonQueuePhotoDisplay from './PoisonQueuePhotoDisplay'

const PoisonQueueAgentInformation = ({
  agentInformation,
}: {
  agentInformation?: AgentInformationBlock
}) => {
  const { id, fullName, photoUri, role } = agentInformation || {}

  if (!agentInformation) return null

  return (
    <AgxColumn gap="spacing-md" fill>
      <AgxTypography id="agent-information" type="heading" size="small">
        Agent Information
      </AgxTypography>

      <AgxRow gap="spacing-lg" fill>
        <PoisonQueuePhotoDisplay photoUri={photoUri} />

        <AgxColumn gap="spacing-md" fill>
          <PoisonQueueInformationTidbit label="Agent Id" value={id} />

          <PoisonQueueInformationTidbit label="Name" value={fullName} />

          <PoisonQueueInformationTidbit label="Role" value={role} />
        </AgxColumn>
      </AgxRow>
    </AgxColumn>
  )
}

export default PoisonQueueAgentInformation
